import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

import {
  BookOpen,
  Buildings,
  Crown,
  Envelope,
  FileText,
  GearSix,
  Key,
  Lightning,
  Scales,
  SignOut,
  SquaresFour,
  UserPlus,
  UsersThree
} from '@phosphor-icons/react';
const AdminLayout = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const menuItems = [
    { name: 'Dashboard', path: '/admin/dashboard', icon: SquaresFour },
    { name: 'Organizations', path: '/admin/organizations', icon: Buildings },
    { name: 'UsersThree', path: '/admin/users', icon: UsersThree },
    { name: 'Plans & Limits', path: '/admin/plans', icon: Crown },
    { name: 'Affiliates', path: '/admin/affiliates', icon: UserPlus },
    { name: 'Blogs', path: '/admin/blogs', icon: FileText },
    { name: 'Ebooks', path: '/admin/ebooks', icon: BookOpen },
    { name: 'Messages', path: '/admin/messages', icon: Envelope },
    { name: 'Legal', path: '/admin/legal', icon: Scales },
    { name: 'LLM Keys', path: '/admin/llm-keys', icon: Key },
    { name: 'Settings', path: '/admin/settings', icon: GearSix },
  ];

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  return (
    <div className="min-h-screen bg-[#161B26]">
      {/* Sidebar */}
      <aside className="fixed left-0 top-0 h-full w-64 glass border-r border-[rgba(255,255,255,0.1)] z-50">
        <div className="p-6">
          <Link to="/" className="flex items-center gap-3 group mb-8">
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-r from-[#6366F1] to-[#EC4899] rounded-lg blur-md opacity-70"></div>
              <div className="relative bg-gradient-to-br from-[#6366F1] to-[#8B5CF6] p-2 rounded-lg">
                <Lightning size={20} className="text-white" strokeWidth={2.5} />
              </div>
            </div>
            <div>
              <span className="text-lg font-bold" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
                <span className="text-white">MAN</span>
                <span className="text-[#EC4899] mx-1">&</span>
                <span className="text-white">MACHINE</span>
              </span>
              <p className="text-xs text-[#A0AEC0]">Admin Panel</p>
            </div>
          </Link>

          <nav className="space-y-2">
            {menuItems.map((item) => {
              const Icon = item.icon;
              const isActive = location.pathname === item.path;
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-all ${
                    isActive
                      ? 'bg-gradient-to-r from-[#6366F1]/20 to-[#EC4899]/20 text-white'
                      : 'text-[#A0AEC0] hover:bg-[rgba(255,255,255,0.05)] hover:text-white'
                  }`}
                >
                  <Icon size={20} />
                  <span className="font-medium">{item.name}</span>
                </Link>
              );
            })}
          </nav>
        </div>

        <div className="absolute bottom-0 left-0 right-0 p-6 border-t border-[rgba(255,255,255,0.1)]">
          <div className="flex items-center justify-between mb-3">
            <div>
              <p className="text-sm text-white font-medium">{user?.username}</p>
              <p className="text-xs text-[#718096]">Administrator</p>
            </div>
          </div>
          <button
            onClick={handleLogout}
            className="flex items-center gap-2 text-[#A0AEC0] hover:text-white transition-colors w-full"
          >
            <SignOut size={18} />
            <span className="text-sm">Sign Out</span>
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <main className="ml-64 p-8">
        {children}
      </main>
    </div>
  );
};

export default AdminLayout;